import { isAudioFile } from "./audioExtensions";
import { isZipDvbFile } from "./isZipDvbFile";
import { isSubtitlesFile } from "./subtitleExtensions";
import { isVideoFile } from "./videoExtensions";

export const isMatchingFileExtension = (extension: string): boolean =>
    isSubtitlesFile(extension) || isVideoFile(extension) || isAudioFile(extension) || isZipDvbFile(extension);
